import { useTranslations } from 'next-intl';

import Backdrop from '@/components/backdrop';
import Banner from '@/components/banner';
import { Button } from '@/components/button';

import CookieContent from './cookie-content';
import { useCookiePolicy } from './useCookiePolicy';

interface CookiePolicyProps {
  isCookieConsent: true | undefined;
  isPosthogIdentify: true | false | undefined;
}

const CookiePolicy: React.FC<CookiePolicyProps> = ({ isCookieConsent, isPosthogIdentify }: CookiePolicyProps) => {
  const t = useTranslations('layout.cookies');
  const { isCookieConsentAllowed, isPosthogIdentifyAllowed, handleAllowFromFirstWindow, handleAllowFromSecondWindow, handleNotAllow } =
    useCookiePolicy(isCookieConsent, isPosthogIdentify);

  return (
    <Backdrop isOpen={!isCookieConsentAllowed || isPosthogIdentifyAllowed === undefined} isChildrenBottomLeft={true}>
      <Banner isOpen={!isCookieConsentAllowed || isPosthogIdentifyAllowed === undefined} isDisableCloseIcon={true} isCookiePrivacy={true}>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center">
              <p className="text-[22px] lg:text-2xl text-text-primary text-bold tracking-2pct">{t('title')}</p>
            </div>
            <CookieContent isCookieConsentAllowed={isCookieConsentAllowed} />
          </div>
          <div className="flex flex-row items-center gap-8">
            <Button variant="secondary" size="large" onClick={handleNotAllow}>
              {t('deny')}
            </Button>
            <Button size="large" onClick={isCookieConsentAllowed === false ? handleAllowFromSecondWindow : handleAllowFromFirstWindow}>
              {t('allow')}
            </Button>
          </div>
        </div>
      </Banner>
    </Backdrop>
  );
};

export default CookiePolicy;
